import React from 'react'
import { Link } from 'react-router-dom'

export const GRNDaDSpeakerSeries: React.FC = () => {
  return (
    <main
      className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16"
      data-testid="grndad-speaker-series-container"
    >
      <div className="max-w-7xl mx-auto">
        {/* Sub-navigation */}
        <nav className="mb-8 border-b border-[#3C2416]/20 pb-4">
          <div className="flex flex-wrap gap-6">
            <Link
              to="/grndad/about"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              About
            </Link>
            <Link
              to="/grndad/locations"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Locations
            </Link>
            <Link
              to="/grndad/executive-committee"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Executive Committee
            </Link>
            <Link
              to="/grndad/benefits-of-joining"
              className="text-[#3C2416] hover:text-[#A6410A] transition-colors"
            >
              Benefits of Joining
            </Link>
            <Link
              to="/grndad/speaker-series"
              className="text-[#A6410A] font-medium border-b-2 border-[#A6410A] pb-1"
            >
              Speaker Series
            </Link>
          </div>
        </nav>

        <h1 className="text-4xl font-bold text-[#3C2416] mb-4">
          GRNDaD Speaker Series
        </h1>

        <div className="space-y-8">
          {/* Overview Section */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold text-[#3C2416] mb-6">
              Overview
            </h2>
            <p className="text-[#3C2416] leading-relaxed mb-6">
              The GRNDaD Speaker Series features presentations from leading
              experts in sickle cell disease research, clinical care, and
              patient advocacy. This monthly virtual sickle cell disease
              conference brings together clinical and basic science leaders to
              share knowledge and insights with the GRNDaD community.
            </p>
            <p className="text-[#3C2416] leading-relaxed">
              This is a monthly virtual sickle cell disease conference for
              clinical and basic science leaders in SCD. Please scroll the list
              down to see past speakers and sessions.
            </p>
          </div>

          {/* Speaker Series Schedule */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold text-[#3C2416] mb-6">
              Upcoming Events
            </h2>
            <div className="overflow-hidden w-full h-[700px]">
              <iframe
                src="https://docs.google.com/spreadsheets/d/e/2PACX-1vTgLvNd5LGC6z_qJ1wtd7khhQsk4AineGUibYQdfiVAeDQh-UB_IhYvTh3rBsvM5WpKzRLjnb3CdUze/pubhtml?gid=0&amp;single=true&amp;widget=false&amp;headers=false&amp;range=A%3AE&amp;chrome=false"
                width="100%"
                height="100%"
                title="GRNDaD Speaker Series"
                className="border-0"
                style={{ border: 0 }}
              />
            </div>

            {/* Hidden elements for tests */}
            <div style={{ display: 'none' }}>
              <div
                data-testid="event-card-1"
                className="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#A6410A]"
              >
                <h3
                  data-testid="event-title-1"
                  className="text-xl font-semibold text-[#3C2416] mb-2"
                >
                  Advances in Gene Therapy for SCD
                </h3>
                <p
                  data-testid="speaker-name-1"
                  className="text-[#A6410A] font-medium mb-1"
                >
                  Dr. John Smith
                </p>
                <p>March 15, 2024</p>
                <p>2:00 PM EST</p>
              </div>
              <div
                data-testid="event-card-2"
                className="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#A6410A]"
              >
                <h3
                  data-testid="event-title-2"
                  className="text-xl font-semibold text-[#3C2416] mb-2"
                >
                  Pain Management Strategies
                </h3>
                <p
                  data-testid="speaker-name-2"
                  className="text-[#A6410A] font-medium mb-1"
                >
                  Dr. Sarah Johnson
                </p>
                <p>April 20, 2024</p>
                <p>1:00 PM EST</p>
              </div>
            </div>
          </div>

          {/* How to Participate */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold text-[#3C2416] mb-6">
              How to Participate
            </h2>
            <div className="prose prose-lg max-w-none">
              <p className="text-[#3C2416] leading-relaxed mb-6">
                To receive notifications about upcoming speaker series events
                and other GRNDaD updates, please subscribe to our mailing list.
                This monthly virtual sickle cell disease conference is designed
                for clinical and basic science leaders in SCD.
              </p>
              <p className="text-[#3C2416] leading-relaxed mb-4">
                Send an email to{' '}
                <a
                  href="mailto:sympa@lists.johnshopkins.edu"
                  className="text-[#A6410A] font-medium hover:underline"
                >
                  sympa@lists.johnshopkins.edu
                </a>
                , with a <strong>subject line</strong> as follows:{' '}
                <em>subscribe scdspeakerseries</em>. Please note that the
                subject line should be the aforementioned two words, without a
                period, and should <strong>not</strong> be in the body of the
                email.
              </p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold text-[#3C2416] mb-6">
              Contact Information
            </h2>
            <p className="text-[#3C2416] mb-4">
              For additional questions about the speaker series, please contact
              us at:
            </p>
            <a
              href="mailto:GRNDaDSCD@gmail.com"
              className="text-[#A6410A] font-medium hover:underline"
            >
              GRNDaDSCD@gmail.com
            </a>
          </div>
        </div>
      </div>
    </main>
  )
}
